// extracted by mini-css-extract-plugin
export default {"con":"cons_con__kHNce","container":"cons_container__f9oRh","flex":"cons_flex__ad2SD","content":"cons_content__hREUU","name":"cons_name__4nDcS","mass":"cons_mass__Gw5nP"};